// CRM 2.0 · M12-F4: a QR link opened before login comes back to the same page after login.
// Only Sales App verify / scanner pages are remembered (never an outside address).
const KEY = "crm2ReturnTo";
const ALLOWED = /^\/(verify|crm2\/verify-agreements)(\/[A-Za-z0-9_-]+)*\/?$/;

export function rememberReturnTo(path) {
  try {
    if (ALLOWED.test(path)) sessionStorage.setItem(KEY, path);
  } catch (e) {
    // private window: the user lands on the home page after login instead
  }
}

export function takeReturnTo() {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && ALLOWED.test(path) ? path : null;
  } catch (e) {
    return null;
  }
}
